export default {
  methods: {
    formatearZonaHoraria(fecha) {
      fecha.setTime(
        fecha.getTime() + fecha.getTimezoneOffset() * 60 * 1000 * -1
      )
      return fecha.toISOString()
    },
    notificarAccionCompletada(mensaje) {
      this.notificarMensaje('is-success', mensaje)
    },
    notificarError(mensaje) {
      this.notificarMensaje('is-danger', mensaje)
    },
    notificarMensaje(tipo, mensaje) {
      this.$buefy.toast.open({
        duration: 5000,
        message: mensaje,
        position: 'is-bottom',
        type: tipo
      })
    },
    procesarError(error) {
      const err = Object.assign({}, error)
      let mensaje = ''
      switch (err.code) {
        case 'ECONNABORTED':
          mensaje = 'Ha ocurrido un problema de conexión con el servidor.'
          break
        default:
          if (err.response) {
            if ([400, 404].includes(err.response.status)) {
              mensaje =
                'Ocurrió un problema al procesar la solicitud en el servidor'
              if (err.response.data.error) {
                mensaje = err.response.data.error
              } else {
                if (err.response.data) {
                  mensaje = err.response.data
                }
              }
            } else {
              const errores = err.response.data.errors
              if (errores) {
                mensaje = '<p>Ocurrieron los siguientes errores:</p>'
                mensaje += Object.values(errores).map(
                  (item) => `<p>${item[0]}</p>`
                )
              } else {
                mensaje = err.response.data.error
              }
            }
          } else mensaje = error.toString()
      }
      this.notificarError(mensaje)
    },
    debounce(fn, delay) {
      var timeout = null
      return function () {
        clearTimeout(timeout)
        var args = arguments
        var that = this
        timeout = setTimeout(function () {
          fn.apply(that, args)
        }, delay)
      }
    }
  }
}
